export const ShippingListStatus = Object.freeze({
    PENDING: 0,
    PACKAGED: 1,
    CANCELLED: 2,
    WAITING_ALTERNATE_PRODUCTS: 3,
    READY_FOR_COLLECTION: 4,
    SHIPPED: 5,
    DELIVERED: 6,
    OUT_OF_STOCK: 7,
    RETURN_REQUESTED: 8,
    WAITING_FOR_PAYMENT: 14,
    PREPARING: 15,
    WAITING_FOR_SHIPMENT: 16,
    WAITING_PARTIAL_SHIPMENT: 17,
    LOST_PACKAGE: 18,
    SHIPPING_CONFIRMED: 19,
    AWAITING_INVOICE_AND_DELIVERY_NOTE: 20,
    INVOICED_TO_CARGO_COMPANY: 21,
    ALL_ITEMS_RETURNED: 22,
    PENDING_PARTIAL_SHIPMENT_CONFIRM: 23,
    NOT_DELIVERED: 24,
    PENDING_INVOICE_LOST_PACKAGE: 26,
    APPROVED: 27,
    WAITING_FOR_APPROVAL: 28,
    STORE_ORDER_PENDING: 29,
    ALL_ITEMS_REDISTRIBUTED: 30,
    CONSOLIDATED: 31,
    RESHIPPING: 32,
    INTERNAL_PROCESSING: 99,
});

export const cargoCompanyShipmentStates: any = [
    { label: 'lostCargo.statusEnums.pending', value: ShippingListStatus.PENDING },
    { label: 'lostCargo.statusEnums.packaged', value: ShippingListStatus.PACKAGED },
    { label: 'lostCargo.statusEnums.canceled', value: ShippingListStatus.CANCELLED },
    { label: 'lostCargo.statusEnums.waitingAlternateProducts', value: ShippingListStatus.WAITING_ALTERNATE_PRODUCTS },
    { label: 'lostCargo.statusEnums.readyForCollection', value: ShippingListStatus.READY_FOR_COLLECTION },
    { label: 'lostCargo.statusEnums.shipped', value: ShippingListStatus.SHIPPED },
    { label: 'lostCargo.statusEnums.delivered', value: ShippingListStatus.DELIVERED },
    { label: 'lostCargo.statusEnums.outOfStock', value: ShippingListStatus.OUT_OF_STOCK },
    { label: 'lostCargo.statusEnums.returnRequested', value: ShippingListStatus.RETURN_REQUESTED },
    { label: 'lostCargo.statusEnums.waitingForPayment', value: ShippingListStatus.WAITING_FOR_PAYMENT },
    { label: 'lostCargo.statusEnums.preparing', value: ShippingListStatus.PREPARING },
    { label: 'lostCargo.statusEnums.waitingForShipment', value: ShippingListStatus.WAITING_FOR_SHIPMENT },
    { label: 'lostCargo.statusEnums.waitingPartialShipment', value: ShippingListStatus.WAITING_PARTIAL_SHIPMENT },
    { label: 'lostCargo.statusEnums.packageLost', value: ShippingListStatus.LOST_PACKAGE },
    { label: 'lostCargo.statusEnums.shippingConfirmed', value: ShippingListStatus.SHIPPING_CONFIRMED },
    {
        label: 'lostCargo.statusEnums.awaitingInvoiceAndDeliveryNote',
        value: ShippingListStatus.AWAITING_INVOICE_AND_DELIVERY_NOTE,
    },
    { label: 'lostCargo.statusEnums.invoicedToCargoCompany', value: ShippingListStatus.INVOICED_TO_CARGO_COMPANY },
    { label: 'lostCargo.statusEnums.allItemsReturned', value: ShippingListStatus.ALL_ITEMS_RETURNED },
    {
        label: 'lostCargo.statusEnums.pendingPartialShipmentConfirm',
        value: ShippingListStatus.PENDING_PARTIAL_SHIPMENT_CONFIRM,
    },
    { label: 'lostCargo.statusEnums.notDelivered', value: ShippingListStatus.NOT_DELIVERED },
    {
        label: 'lostCargo.statusEnums.pendingInvoiceLostPackage',
        value: ShippingListStatus.PENDING_INVOICE_LOST_PACKAGE,
    },
    { label: 'lostCargo.statusEnums.approved', value: ShippingListStatus.APPROVED },
    { label: 'lostCargo.statusEnums.waitingForApproval', value: ShippingListStatus.WAITING_FOR_APPROVAL },
    { label: 'lostCargo.statusEnums.storeOrderPending', value: ShippingListStatus.STORE_ORDER_PENDING },
    { label: 'lostCargo.statusEnums.allItemsRedistributed', value: ShippingListStatus.ALL_ITEMS_REDISTRIBUTED },
    { label: 'lostCargo.statusEnums.consolidated', value: ShippingListStatus.CONSOLIDATED },
    { label: 'lostCargo.statusEnums.reshipping', value: ShippingListStatus.RESHIPPING },
    { label: 'lostCargo.statusEnums.internalProcessing', value: ShippingListStatus.INTERNAL_PROCESSING },
];
